/* eslint-disable eqeqeq */
import { useState, useEffect } from 'react';
import { getClientByVersion, getClientInfo } from 'services/paramsConfigService';
import { ToastContent, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handleLoader, handleNotFound } from 'redux/counterSlice';
import AddUpdateConfiguration from './addUpdateConfiguration';



function ParamConfiguration({
}: any) {

    const location = useLocation()
    const dispatch = useDispatch();

    // const [questions, setQuestions] = useState<string[]>([]);
    const [fieldData, setFieldData] = useState({});
    const [clientVersion, setClientVersion] = useState<{ name: string }>({ name: "" });
    // const [inputFile1, setInputFile1] = useState<string>("");
    // const [inputFile2, setInputFile2] = useState<string>("");
    // const [inputFile1Base, setInputFile1Base] = useState<string>("");
    // const [inputFile2Base, setInputFile2Base] = useState<string>("");
    // const [clientVersion, setClientVersion] = useState<string>("");
    // const [versionOptions, setVersionOptions] = useState<string[]>([]);
    // const [isBackendDataChanged, setIsBackendDataChanged] = useState(false)

    const queryParams = new URLSearchParams(location.search);
    const envParam = localStorage.getItem("clientName")




    const getFieldData = async (env: any) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getClientInfo(env, true);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setFieldData(result)
            console.log("result", result)
            dispatch(handleLoader(false));
            // setQuestions(result.default_questions && result.default_questions)
            // setInputFile1Base(result?.logos_urls?.logo_home_page)
            // setInputFile2Base(result?.logos_urls?.logo_side_img)
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            dispatch(handleLoader(false));
        }
    }

    const getFieldDataByVersion = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getClientByVersion(localStorage.getItem("clientName"), clientVersion.name);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setFieldData(result)
            dispatch(handleLoader(false));
            // setQuestions(result.default_questions && result.default_questions)

        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            dispatch(handleLoader(false));
        }
    }


    useEffect(() => {
        if (clientVersion.name !== "") {
            getFieldDataByVersion();
        }
    }, [clientVersion])

    useEffect(() => {
        dispatch(handleNotFound(false))
        // This code will run whenever the URL changes
        if (envParam) {
            getFieldData(envParam)
        } else {
            window.location.origin === 'https://ron.rysun.in:3001' ? getFieldData("ron_prod") : getFieldData("ron_stage")

        }
    }, []);

    return (
        <>
            {(fieldData && Object.keys(fieldData).length > 0) && <AddUpdateConfiguration
                fieldData={fieldData}
                setFieldData={setFieldData}
                getFieldData={getFieldData}
                clientVersion={clientVersion}
                setClientVersion={setClientVersion}
                getFieldDataByVersion={getFieldDataByVersion}
            />}
        </>
    );
}

export default ParamConfiguration;
